<template>
  <div style="display: flex; flex-direction: column; width: 100%; height: 100%">
    <div style="display: flex">
      <div style="width: 60%">
        <span>
            <Button class="admin-control-reports-button"
                    :class="activeSheetTab === 0 ? 'admin-control-reports-button-enabled' : ''"
                    :label="windowWidth >= 1414 ? $t('reports.assetsImported') : $t('reports.assetsImported').slice(0, 5) + '...'"
                    v-tooltip="windowWidth < 1414 ? $t('reports.assetsImported') : ''"
                    @click="activeSheetTab = 0"/>
            <Button class="admin-control-reports-button"
                    :class="activeSheetTab === 1 ? 'admin-control-reports-button-enabled' : ''"
                    :label="windowWidth >= 1414 ? $t('reports.jobsCreated') : $t('reports.jobsCreated').slice(0, 5) + '...'"
                    v-tooltip="windowWidth < 1414 ? $t('reports.jobsCreated') : ''"
                    @click="activeSheetTab = 1"/>
            <Button class="admin-control-reports-button"
                    :class="activeSheetTab === 2 ? 'admin-control-reports-button-enabled' : ''"
                    :label="windowWidth >= 1414 ? $t('reports.jobsCompleted') : $t('reports.jobsCompleted').slice(0, 5) + '...'"
                    v-tooltip="windowWidth < 1414 ? $t('reports.jobsCompleted') : ''"
                    @click="activeSheetTab = 2"/>
            <Button class="admin-control-reports-button"
                    :class="activeSheetTab === 3 ? 'admin-control-reports-button-enabled' : ''"
                    :label="windowWidth >= 1414 ? $t('reports.allUsers') : $t('reports.allUsers').slice(0, 5) + '...'"
                    v-tooltip="windowWidth < 1414 ? $t('reports.allUsers') : ''"
                    @click="activeSheetTab = 3"/>
        </span>
      </div>
      <div style="display: flex; gap: 5px">
        <CustomDropdown
          v-model:modelValue="selectedPreset"
          show-clear="true"
          :options="presets"
          :label="$t('general.duration')"
          :placeholder="$t('general.duration')"
          class="grid-item"
          style="display: flex; width: calc(10vw - 1px)">
        
        </CustomDropdown>
        
        <Calendar v-model="startDate"
                  @update:modelValue="loadData()"
                  dateFormat="dd.mm.yy"
                  :placeholder="$t('general.startDate')"
        />
        <Calendar v-model="endDate"
                  @update:modelValue="loadData()"
                  dateFormat="dd.mm.yy"
                  :placeholder="$t('general.endDate')"
        />
        
        
        <RoundedLabel style="height: 50px; width: calc(10vw - 1px); border-radius: 8px; cursor: pointer"
                      class="bg-dark-blue col-white"
                      @click="downloadExcel()"
                      :text="$t('general.downloadExcel')"
        />
      </div>
      
      <!--   click on download excel -> switches can now be toggled in dialog   -->
      <div
        v-if="false"
        style="position: relative; display: flex; float: right; width: 70%; height: auto; align-items: center; align-content: center; gap: 20px">
        <Switch v-model="assetsImported" rightLabel="Assets Imported"/>
        <Switch v-model="jobsCreated" rightLabel="Jobs Created"/>
        <Switch v-model="jobsCompleted" rightLabel="Jobs Completed"/>
        <Switch v-model="activeUsers" rightLabel="Active Users"/>
        <Switch v-model="allUsers" rightLabel="All Users"/>
      </div>
    </div>
    
    <div v-if="activeSheetTab === 0" style="padding-top: 5px; height: 100%; width: 100%">
      <DataTable :value="assets" lazy stripedRows scrollable scrollHeight="flex">
        <Column field="id"
                v-if="selectedColumnsAssetsImported.includes('general.id')"
                :header="$t('general.id')"
                style="overflow: hidden"></Column>
        <Column field="name"
                v-if="selectedColumnsAssetsImported.includes('general.name')"
                :header="$t('general.name')"
                style="overflow: hidden"></Column>
        <Column v-if="selectedColumnsAssetsImported.includes('general.created')"
                :header="$t('general.created')"
                style="overflow: hidden"
                class="flex-center">
          <template #body="slotProps">
            {{getDateString(slotProps.data.created)}}
          </template>
        </Column>
        <Column field="jobCount"
                v-if="selectedColumnsAssetsImported.includes('general.jobCount')"
                :header="$t('general.jobCount')"
                class="flex-center"
                style="overflow: hidden"></Column>
        <Column
          v-if="selectedColumnsAssetsImported.includes('general.language')"
          :header="$t('general.language')"
          class="flex-center"
          style="overflow: hidden">
          <template #body="slotProps">
            <Flag :countryFlag="slotProps.data.language"
                  v-tooltip="slotProps.data.language"
                  style="float: left; margin-right: 20px"/>
          </template>
        </Column>
        <Column field="group"
                v-if="selectedColumnsAssetsImported.includes('general.group')"
                :header="$t('general.group')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column header="" class="flex-center" style="overflow: hidden">
          <template #header="slotProps">
            <MultiSelect
              v-model:model-value="selectedColumnsAssetsImported"
              style="width: 10px; height: 0"
              :options="allColumnsAssetsImported"
            >
              <template #header="slotProps">
                <h4>
                  Select Columns
                </h4>
              </template>
              <template #option="s">
                {{$t(s.option)}}
              </template>
            </MultiSelect>
          </template>
        </Column>
        
        <template #footer="slotProps">
          <div style="display: flex; gap: 50px" class="col-dark-blue">
            <div style="width: 300px">
              <div style="display: flex">
                <div style="display: flex; width: 80%" class="handle-font-overflow">{{
                    $t('reports.totalAssets')
                  }}:
                </div>
                {{assets.length}}
              </div>
              <div style="display: flex">
                <div style="width: 80%" class="handle-font-overflow">{{
                    $t('reports.assetsImportedPerWeek')
                  }}:
                </div>
                {{(assets.length / 52).toFixed(3)}}
              </div>
              <div style="display: flex">
                <div style="width: 80%" class="handle-font-overflow">{{
                    $t('reports.assetsImportedPerMonth')
                  }}:
                </div>
                {{(assets.length / 12).toFixed(3)}}
              </div>
            </div>
            
            <div style="width: 200px; height: 80px">
              <div class="handle-font-overflow">{{$t('reports.assetsByGroup')}}:</div>
              <div style="height: 70px; overflow: auto">
                <div v-for="group in groups" style="display: flex">
                  <div class="handle-font-overflow" style="width: 80%">{{group[0]}}
                  </div>
                  <div class="handle-font-overflow" style="width: 20%">{{group[1]}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </DataTable>
    </div>
    
    <div v-if="activeSheetTab === 1" style="padding-top: 5px; height: 100%; width: 100%">
      <DataTable :value="jobs" lazy stripedRows responsiveLayout="scroll" scrollable scrollHeight="flex">
        <Column field="id"
                v-if="selectedColumnsJobsCreated.includes('general.id')"
                :header="$t('general.id')"
                style="overflow: hidden"></Column>
        <Column field="name"
                v-if="selectedColumnsJobsCreated.includes('general.name')"
                :header="$t('general.name')"
                style="overflow: hidden"></Column>
        <Column
          v-if="selectedColumnsJobsCreated.includes('general.created')"
          :header="$t('general.created')"
          class="flex-center"
          style="overflow: hidden">
          <template #body="slotProps">
            {{getDateString(slotProps.data.created)}}
          </template>
        </Column>
        <Column
          v-if="selectedColumnsJobsCreated.includes('general.masterLanguage')"
          :header="$t('general.masterLanguage')"
          class="flex-center" style="overflow: hidden">
          <template #body="slotProps">
            <Flag :countryFlag="slotProps.data.masterLanguage"
                  v-tooltip="slotProps.data.masterLanguage"
                  style="float: left; margin-right: 20px"/>
          </template>
        </Column>
        <Column field="translator"
                v-if="selectedColumnsJobsCreated.includes('general.translator')"
                :header="$t('general.translator')"
                class="flex-center"
                style="overflow: hidden"></Column>
        <Column field="mamId"
                v-if="selectedColumnsJobsCreated.includes('general.mamId')"
                :header="$t('general.mamId')"
                class="flex-center" style="overflow: hidden">
          <template #body="slotProps">
            {{slotProps.data.mamId}}
          </template>
        </Column>
        <Column field="costCenter"
                v-if="selectedColumnsJobsCreated.includes('general.costCenter')"
                :header="$t('general.costCenter')"
                class="flex-center"
                style="overflow: hidden"></Column>
        <Column
          v-if="selectedColumnsJobsCreated.includes('general.languages')"
          :header="$t('general.languages')"
          class="flex-center" style="overflow: hidden">
          <template #body="slotProps">
            <Flag :countryFlag="slotProps.data.languages"
                  v-tooltip="slotProps.data.languages"
                  style="float: left; margin-right: 20px"/>
          </template>
        </Column>
        <Column
          v-if="selectedColumnsJobsCreated.includes('general.status')"
          :header="$t('general.status')"
          class="flex-center" style="overflow: hidden">
          <template #body="slotProps">
            <Tag :value="slotProps.data.status"
                 :severity="
                         slotProps.data.status === 'MOVIECREATED' ? 'warning' :
                         slotProps.data.status === 'READY_TO_APPROVE' ? 'danger' :
                         slotProps.data.status === 'CLOSED' ? 'success' : 'info'">
            
            </Tag>
          </template>
        </Column>
        
        <Column header="" class="flex-center" style="overflow: hidden">
          <template #header="slotProps">
            <MultiSelect
              v-model:model-value="selectedColumnsJobsCreated"
              style="width: 10px; height: 0"
              :options="allColumnsJobsCreated"
            >
              <template #header="slotProps">
                <h4>
                  Select Columns
                </h4>
              </template>
              <template #option="s">
                {{$t(s.option)}}
              </template>
            </MultiSelect>
          </template>
        </Column>
        <template #footer="slotProps">
          <div class="col-dark-blue">
            <div style="display: flex; width: 300px">
              <div style="display: flex; width: 80%" class="handle-font-overflow">{{$t('reports.totalJobs')}}:</div>
              {{jobs.length}}
            </div>
            <div style="display: flex; width: 300px" class="handle-font-overflow">
              <div style="width: 80%">{{$t('reports.jobsCreatedPerWeek')}}:</div>
              {{(jobs.length / 52).toFixed(3)}}
            </div>
            <div style="display: flex; width: 300px" class="handle-font-overflow">
              <div style="width: 80%">{{$t('reports.jobsCreatedPerMonth')}}:</div>
              {{(jobs.length / 12).toFixed(3)}}
            </div>
          </div>
        </template>
      </DataTable>
    </div>
    
    <div v-if="activeSheetTab === 2" style="padding-top: 5px; height: 100%; width: 100%">
      <DataTable :value="jobsComplete" lazy stripedRows responsiveLayout="scroll" scrollable scrollHeight="flex">
        <Column field="id"
                v-if="selectedColumnsJobsCompleted.includes('general.id')"
                :header="$t('general.id')"
                style="min-width: 250px; overflow: hidden"></Column>
        <Column field="name"
                v-if="selectedColumnsJobsCompleted.includes('general.name')"
                :header="$t('general.name')"
                style="overflow: hidden"></Column>
        <Column field="user"
                v-if="selectedColumnsJobsCompleted.includes('general.translator')"
                :header="$t('general.translator')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column field="group"
                v-if="selectedColumnsJobsCompleted.includes('general.group')"
                :header="$t('general.group')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column field="costCenter"
                v-if="selectedColumnsJobsCompleted.includes('general.costCenter')"
                :header="$t('general.costCenter')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column
          v-if="selectedColumnsJobsCompleted.includes('general.language')"
          :header="$t('general.language')"
          class="flex-center" style="overflow: hidden">
          <template #body="slotProps">
            <Flag :countryFlag="slotProps.data.language"
                  v-tooltip="slotProps.data.language"
                  style="float: left; margin-right: 20px"/>
          </template>
        </Column>
        <Column field="date"
                v-if="selectedColumnsJobsCompleted.includes('general.completed')"
                :header="$t('general.completed')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column header="" class="flex-center" style="overflow: hidden">
          <template #header="slotProps">
            <MultiSelect
              v-model:model-value="selectedColumnsJobsCompleted"
              style="width: 10px; height: 0"
              :options="allColumnsJobsCompleted"
            >
              <template #header="slotProps">
                <h4>
                  Select Columns
                </h4>
              </template>
              <template #option="s">
                {{$t(s.option)}}
              </template>
            </MultiSelect>
          </template>
        </Column>
        <template #footer="slotProps">
          <div class="col-dark-blue">
            <div style="display: flex; width: 300px">
              <div style="width: 80%" class="handle-font-overflow">{{$t('reports.totalJobs')}}:</div>
              {{jobsComplete.length}}
            </div>
            <div style="display: flex; width: 300px" class="handle-font-overflow">
              <div style="width: 80%">{{$t('reports.jobsCompletedPerWeek')}}:</div>
              {{(jobsComplete.length / 52).toFixed(2)}}
            </div>
            <div style="display: flex; width: 300px" class="handle-font-overflow">
              <div style="width: 80%">{{$t('reports.jobsCompletedPerMonth')}}:</div>
              {{(jobsComplete.length / 12).toFixed(2)}}
            </div>
          </div>
        </template>
      </DataTable>
    </div>
    
    <div v-if="activeSheetTab === 3" style="padding-top: 5px; height: 100%; width: 100%">
      <DataTable :value="users" lazy stripedRows responsiveLayout="scroll" scrollable scrollHeight="flex">
        <Column field="id"
                v-if="selectedColumnsUsers.includes('general.id')"
                :header="$t('general.id')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column field="firstName"
                v-if="selectedColumnsUsers.includes('general.firstName')"
                :header="$t('general.firstName')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column field="name"
                v-if="selectedColumnsUsers.includes('general.name')"
                :header="$t('general.name')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column
          v-if="selectedColumnsUsers.includes('general.eMail')"
          :header="$t('general.eMail')"
          class="flex-center" style="overflow: hidden">
          <template #body="slotProps">
            {{slotProps.data.email}}
          </template>
        </Column>
        <Column
          v-if="selectedColumnsUsers.includes('general.country')"
          :header="$t('general.country')"
          class="flex-center" style="max-width: 100px; overflow: hidden">
          <template #body="slotProps">
            <Flag :countryFlag="slotProps.data.country"
                  v-tooltip="slotProps.data.country"
                  style="float: left; margin-right: 20px"/>
          </template>
        </Column>
        <Column field="costCenter"
                v-if="selectedColumnsUsers.includes('general.costCenter')"
                :header="$t('general.costCenter')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column v-if="selectedColumnsUsers.includes('general.role')"
                :header="$t('general.role')"
                class="flex-center" style="max-width: 150px; overflow: hidden">
          <template #body="slotProps">
            <Tag :value="slotProps.data.role"
                 :severity="
                         slotProps.data.role === 'MANAGER' ? 'warning' :
                         slotProps.data.role === 'ADMIN' ? 'danger' :
                         slotProps.data.role === 'TRANSLATOR' ? 'success' : 'info'">
            </Tag>
          </template>
        </Column>
        <Column field="groups"
                v-if="selectedColumnsUsers.includes('general.groups')"
                :header="$t('general.groups')"
                class="flex-center" style="overflow: hidden"></Column>
        <Column header="" class="flex-center" style="overflow: hidden">
          <template #header="slotProps">
            <MultiSelect
              v-model:model-value="selectedColumnsUsers"
              style="width: 10px; height: 0"
              :options="allColumnsUsers"
            >
              <template #header="slotProps">
                <h4>
                  Select Columns
                </h4>
              </template>
              <template #option="s">
                {{$t(s.option)}}
              </template>
            </MultiSelect>
          </template>
        </Column>
        <template #footer="slotProps">
          <div class="col-dark-blue">
            <!--		implement stats for users			-->
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script src="./AdminControlViewReports.ts"></script>
